/**
 * Registers App.useApp().message for legacy messageHelpers callers (non-hook modules).
 */

import React, { useEffect } from 'react';
import { App } from 'antd';
import { registerMessageApi } from '../../utils/messageHelpers';

export const BusinessMessageBridge: React.FC = () => {
  const { message } = App.useApp();

  useEffect(() => {
    registerMessageApi(message);
  }, [message]);

  return null;
};

export default BusinessMessageBridge;
